
import { companyLogoHandler } from '@/mixins';

export default {
    name: "FinAgentNewsSection",
    mixins: [ companyLogoHandler ],

    props: {
        title: {
            type: String,
            default: ''
        },
        isinList: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            isLoading: false,
            currentPage: 1,
            news: [],
            isEnoughData: true,
        }
    },

    watch: {
        isinList: {
            immediate: true,
            handler(items) {                
                this.cancelActiveRequest();
                if (items && items.length > 0) {
                    this.fetchNewsByIsinList(items);
                }
            }
        }
    },

    beforeDestroy() {
        this.cancelActiveRequest();
    },

    methods: {
        cancelActiveRequest() {
            if (this.activeRequest) {
                this.activeRequest.cancel();
            }
        },

        async handleClickLoadMore() {
            this.currentPage++;
            this.fetchNewsByIsinList(this.isinList);
        },
    
        async fetchNewsByIsinList(isinList = []) {
            try {
                this.cancelActiveRequest();
                this.isLoading = true;
                const axiosSource = this.$axios.CancelToken.source();
                const cancelToken = axiosSource.token;
                this.activeRequest = { cancel: axiosSource.cancel, msg: "Cancel loading news..." };   
                const url = '/api/news';
                const params = {
                    isin: isinList,
                    page: this.currentPage,
                    limit: 5,
                };
                const res = await this.$axios.get(url, { params, cancelToken });
                const data = res?.data || [];

                if (data.length > 0) {
                    this.news.push(...data);
                }

                // when the API return empty, this means we fetch reach to the last page
                this.isEnoughData = data.length === 0;                
                this.activeRequest = null;
                this.isLoading = false;
            } catch (error) {                
                if (this.$axios.isCancel(error)) {
                    return
                }
                this.isLoading = false;
                this.activeRequest = null;
            }
        },
    },
}
